var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_vm._v("\r\n\t\t加载中...\r\n\t")])
}
var staticRenderFns = []

export { render, staticRenderFns }